import { useTranslation } from "react-i18next";
import Menu from "src/components/Menu";
import { Flex } from "@chakra-ui/react";
import RoundButton from "src/components/RoundButton/RoundButton";
import Caption from "src/atoms/typography/Caption";
import { useParentStation } from "../ParentStation/Context";
import { ReactComponent as LowLightAuto } from "../active-feature/icons/low-light-auto.svg";
import { ReactComponent as LowLightOff } from "../active-feature/icons/low-light-off.svg";
import { useEffect } from "react";

export default function LowLightMenu({
  isOpen,
  onClose,
  lowLightMode,
  lowLightRef
}) {
  const { t } = useTranslation();
  const parentStation = useParentStation();
  const { handleLowLightModeChange } = parentStation;
  const isActive = lowLightMode === "LL_AUTO";

  useEffect(() => {
    if (!lowLightRef && isOpen) {
      onClose();
    }
  }, [lowLightRef, isOpen, onClose]);

  return (
    <Menu anchorEl={lowLightRef} isOpen={isOpen} onClose={onClose}>
      <Flex py="16px" px="24px" width="100%" columnGap="24px" bg="black70">
        <Flex
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <RoundButton
            onClick={() => handleLowLightModeChange("LL_AUTO")}
            color={isActive ? "surfaceElevated1" : "white"}
            bg={isActive ? "white" : "white12"}
            iconFill={isActive ? "black54" : "white"}
            size="40px"
            icon={LowLightAuto}
          />
          <Caption color="white70" mt="6px">
            {t("auto")}
          </Caption>
        </Flex>

        <Flex
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <RoundButton
            onClick={() => handleLowLightModeChange("LL_OFF")}
            color={!isActive ? "surfaceElevated1" : "white"}
            bg={!isActive ? "white" : "white12"}
            iconFill={!isActive ? "black54" : "white"}
            size="40px"
            icon={LowLightOff}
          />
          <Caption color="white70" mt="6px">
            {t("off")}
          </Caption>
        </Flex>
      </Flex>
    </Menu>
  );
}
